module.exports = {
  env: process.env.NODE_ENV || process.env.REACT_APP_ENV || "production",
  port: process.env.PORT || process.env.REACT_APP_PORT || "3001",
  api: process.env.REACT_APP_API_ENDPOINT,
  frontend: process.env.REACT_APP_FRONTEND_ENDPOINT,
  basepath: process.env.REACT_APP_BASEPATH,
  reCaptchaKey: process.env.REACT_APP_RECAPTCHA_SITEKEY,
  revalidateSecret: process.env.REACT_APP_REVALIDATE_SECRET,
  antd: {
    theme: {
      token: {
        colorPrimary: "#4a6b49",
        colorPrimaryBg: "#c6d9c6",
        colorInfo: "#4a6b49",
      },
    },
  },
};
